import {Controller} from "stimulus"
import b2b_controller, {create_array_for_product} from "./b2b_controller";
import {get_contract, get_tariffs} from "./rentaContractModalityTariff_controller";
import flatpickr from "flatpickr";
import {flatpick_lang} from "./flatpickr_controller";

export default class extends Controller {
    static targets = ["select", "grid", "item"]

    connect() {
        console.log("Sortable controller connected");

        /*flatpickr("#home_date_range", {
            mode: "range",
            dateFormat: "Y-m-d",
            locale: flatpick_lang,
            /!*minDate: "today",*!/
            minDate: new Date().fp_incr(parseInt(home_product[data_home_modality[1]].reservation_time)),
            /!*showMonths: 2,*!/
            onChange: function(selectedDates, dateStr, instance) {
                if (selectedDates.length === 1) {
                    // Cuando se selecciona la fecha de inicio
                    const startDate = selectedDates[0];
                    const maxDays = home_product[data_home_modality[1]].max_length_reservation; // Cambia este valor por los días que necesites

                    // Calcular la fecha máxima (X días después de la fecha de inicio)
                    const maxDate = new Date(startDate);
                    maxDate.setDate(maxDate.getDate() + maxDays);

                    // Actualizar la configuración con la nueva fecha máxima
                    instance.set('maxDate', maxDate);
                } else if (selectedDates.length === 0) {
                    // Cuando no hay fechas seleccionadas, resetear maxDate
                    instance.set('maxDate', null);
                }
            }
        });*/
    }

    sort() {
        const sortValue = this.selectTarget.value
        const items = Array.from(this.itemTargets)

        // Desvanecer y contraer el grid
        this.gridTarget.style.opacity = '0'
        this.gridTarget.style.transform = 'scale(0.95)'
        this.gridTarget.style.transition = 'opacity 0.4s ease, transform 0.4s ease'

        // Ordenar los items según el criterio seleccionado
        items.sort((a, b) => {
            const aPrice = parseFloat(a.dataset.price) || 0
            const bPrice = parseFloat(b.dataset.price) || 0
            const aRooms = parseInt(a.dataset.rooms) || 0
            const bRooms = parseInt(b.dataset.rooms) || 0
            const aName = a.dataset.name || ''
            const bName = b.dataset.name || ''

            switch (sortValue) {
                case 'price-asc':
                    return aPrice - bPrice

                case 'price-desc':
                    return bPrice - aPrice

                case 'rooms-desc':
                    return bRooms - aRooms

                case 'rooms-asc':
                    return aRooms - bRooms

                case 'name-asc':
                    return aName.localeCompare(bName)

                case 'name-desc':
                    return bName.localeCompare(aName)

                default:
                    return 0
            }
        })

        // Esperar a que termine la transición de salida
        setTimeout(() => {
            // Limpiar el grid
            this.gridTarget.innerHTML = ''

            // Agregar cada item
            items.forEach((item, index) => {
                // Estilos iniciales para animación de entrada
                item.style.opacity = '0'
                item.style.transform = 'translateX(-20px) scale(0.9)'
                item.style.transition = 'all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)'
                item.style.transitionDelay = (index * 0.1) + 's' // Efecto cascada

                this.gridTarget.appendChild(item)

                // Animar la entrada después de un breve delay
                setTimeout(() => {
                    item.style.opacity = '1'
                    item.style.transform = 'translateX(0) scale(1)'
                }, 10)
            })

            // Animar el grid completo
            this.gridTarget.style.opacity = '1'
            this.gridTarget.style.transform = 'scale(1)'

        }, 400) // Match con la duración de la transición de salida
    }

    setRangeDate(e) {
        /*home_date_range.on('change', function (e) {*/
        /*let dates_range = e.target.value.split(' a ');*/
        let dates_range = e.target.value.split(flatpick_lang.rangeSeparator);
        let ini_date = dates_range[0].split('-')
        if (dates_range.length > 1) {
            let fin_date = dates_range[1].split('-')
            create_array_for_product('from_date', `${ini_date[2]}/${ini_date[1]}/${ini_date[0].slice(-2)}`);
            create_array_for_product('to_date', `${fin_date[2]}/${fin_date[1]}/${fin_date[0].slice(-2)}`);
        }
        /*})*/
    }

    addCart(e) {
        console.log(e.target.dataset);
        console.log(e.target.dataset.modalityCode);

        let from_date = create_array_for_product('from_date', '', 'show')
        let to_date = create_array_for_product('to_date', '', 'show')

        create_array_for_product('', '', 'clear');

        create_array_for_product('from_date', from_date)
        create_array_for_product('to_date', to_date)

        create_array_for_product('modality_code', e.target.dataset.modalityCode);
        create_array_for_product('adult', parseInt(e.target.dataset.adult));
        create_array_for_product('children', parseInt(e.target.dataset.children));
        create_array_for_product('plan', 'CP');
        create_array_for_product('modalities_name', e.target.dataset.modalityName);

        create_array_for_product('product_type', 'home');
        create_array_for_product('destination_id', parseInt(e.target.dataset.destinationId));
        create_array_for_product('destination_code', parseInt(e.target.dataset.destinationCode));
        create_array_for_product('text_destination', e.target.dataset.destinationName);
        create_array_for_product('category_id', parseInt(e.target.dataset.productId));
        create_array_for_product('category_code', e.target.dataset.productCode);
        create_array_for_product('dealer_code', parseInt(e.target.dataset.dealerCode));
        create_array_for_product('dealer_name', e.target.dataset.dealerName);
        create_array_for_product('dealer_id', parseInt(e.target.dataset.dealerId));
        create_array_for_product('amount', 1);
        create_array_for_product('pax', 1);

        get_contract(e.target.dataset.dealerId).then(gcontract => {
            // FIX (2026-08-05): no continuar el proceso si el contrato falló.
            if (!gcontract.next) {
                toastr.error(I18n.t('main.header.shopping_cart.selling_contract_text'), I18n.t('main.header.shopping_cart.selling_contract'));
                return;
            }
            get_tariffs(null).then(gtariffs => {
                if (!gtariffs.next) {
                    toastr.error(I18n.t('main.header.shopping_cart.selling_price_text'), I18n.t('main.header.shopping_cart.selling_price'));
                    return;
                }
                b2b_controller.create_reservation(e);

                /* Buscar el span de error justo después */
                const $errorSpan = $('#home_date_range_details').parent().find('span.helper-text');
                if ($errorSpan.length > 0) {
                    $errorSpan.css('position', 'absolute');
                }
            })
        })
    }
}